import React, { Component, createContext } from "react";

import { firestore, auth, setDemoUser } from "../firebase";

export const CurrentUserContext = createContext({ currentUser: null });
export const AuthReadyContext = createContext(false);

class CurrentUserProvider extends Component {
  state = { currentUser: null, authReady: false };

  componentDidMount = async () => {
    this.unsubscribeFromAuth = auth.onIdTokenChanged(async user => {
      // Token refresh and password reauthentication must preserve mounted drafts.
      // Keep the existing profile listener when the signed-in identity is unchanged.
      if (user && this.authUid === user.uid && this.unsubscribeFromUserDocument) return;
      this.authUid = user?.uid || null;
      if (this.unsubscribeFromUserDocument) {
        this.unsubscribeFromUserDocument();
        this.unsubscribeFromUserDocument = null;
      }

      setDemoUser(null);
      this.setState({currentUser: null, authReady: false});
      if (user) {
        this.unsubscribeFromUserDocument = firestore
          .collection("users")
          .doc(user.email)
          .onSnapshot(
            {includeMetadataChanges: true},
            userDocument => {
              // Do not switch mode/remount drafts before a settings write is confirmed.
              if (userDocument.metadata.hasPendingWrites) return;
              if (!userDocument.exists) {
                setDemoUser(null);
                this.setState({
                  currentUser: { email: user.email },
                  authReady: true,
                });
                return;
              }

              setDemoUser({email: user.email, ...userDocument.data()});
              this.setState({
                currentUser: {
                  email: user.email,
                  ...userDocument.data(),
                },
                authReady: true,
              });
            },
            error => {
              setDemoUser(null);
              console.error('Error update user document: ', error);
              this.setState({ currentUser: null, authReady: true });
            }
          );
        return;
      }
      this.setState({ currentUser: null, authReady: true });
    }, error => {console.error('Error update user state: ', error)});
  };

  componentWillUnmount = () => {
    this.unsubscribeFromAuth();
    if (this.unsubscribeFromUserDocument) {
      this.unsubscribeFromUserDocument();
    }
  };

  render() {
    const { children } = this.props;
    const { currentUser, authReady } = this.state;

    return (
      <AuthReadyContext.Provider value={authReady}>
        <CurrentUserContext.Provider value={currentUser}><React.Fragment key={`${currentUser?.email}:${currentUser?.role}:${currentUser?.status}:${currentUser?.demoMode === true}`}>{children}</React.Fragment></CurrentUserContext.Provider>
      </AuthReadyContext.Provider>
    );
  }
}

export default CurrentUserProvider;
